import api from "./api";
import currentUserId from "../reduxSaga/sagas/requests/currentUserId";
import UtilsUrl from "../utils/UtilsUrl";

class ZoneService {
  addZone(data) {
    return api.post(UtilsUrl.ZoneURL() + "/createZone", data);
  }
  updateZone(data) {
    return api.put(UtilsUrl.ZoneURL() + "/updateZone", data);
  }
  getZone(id) {
    return api.get(UtilsUrl.ZoneURL() + `/getZone/${id}`);
  }
  getZonesBySociete(id) {
    return api.get(UtilsUrl.ZoneURL() + `/getZonesBySociete/${id}`);
  }

  getZonesById(id) {
    return api.get(UtilsUrl.ZoneURL() + `/getZonesByUserCreated/${id}`);
  }
  getSocietesByZone(id) {
    return api.get(UtilsUrl.ZoneURL() + `/getSocietesByZone/${id}`);
  }
  AffectZonesToSociete(data) {
    return api.put(UtilsUrl.ZoneURL() + `/affectZonesToSociete`, data);
  }
  deleteZone(id, deleted) {
    return api.put(UtilsUrl.ZoneURL() + `/deleteZone/${id}/${deleted}`);
  }
  deleteUserZone(idZone, idUser, idSocieteToDelete, isDeleted) {
    return api.put(UtilsUrl.ZoneURL() + `/deleteSocieteFromZone/${idZone}/${idUser}/${idSocieteToDelete}/${isDeleted}`);
  }
  getZonesBySociete(idUser, idSociete ) {
    return api.get(UtilsUrl.ZoneURL() + `/getZonesBySociete/${idUser}/${idSociete}`);
  } 

}
export default new ZoneService();
